import { createContext } from 'react';
import { SearchPreviewAction } from '../actions/searchPreview';

export const SearchPreviewDispatchContext = createContext<React.Dispatch<SearchPreviewAction>>(() => {});
